import getSymbolFromCurrency from "currency-symbol-map"

export const priceFormattingSymbol = (price, currencyValue) => {
    if (!price) {
      price = 0.0
    }
    const currency = currencyValue 
    const currencySymbol = getSymbolFromCurrency(currency)
  
    const formattedAmount = `${parseFloat(price)
      .toFixed(2)
      .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')}`
  
    return `${currencySymbol ? currencySymbol : ''}${formattedAmount}`
  }
  export const formatDateToYYYYMMDD = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  export const formatDateToDDMMYYYY = (date) => {
    if (!(date instanceof Date)) date = new Date(date);
    if (isNaN(date.getTime())) return '';
    let dd = date.getDate();
    let mm = date.getMonth() + 1; // Months are zero-indexed
    const yyyy = date.getFullYear();
    dd = dd < 10 ? `0${dd}` : dd;
    mm = mm < 10 ? `0${mm}` : mm;
    return `${dd}-${mm}-${yyyy}`;
  };

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB'); // This will format as dd/mm/yyyy
};
export const formatDateRange = (startDate, endDate) => {

  const start =  formatDateToDDMMYYYY(startDate)
  const end = formatDateToDDMMYYYY(endDate)

  return `${start} - ${end}`;
};

export const formatDateToDDMM = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  let dd = date.getDate();
  let mm = date.getMonth() + 1; // Months are zero-indexed
  const yyyy = date.getFullYear();
  
  dd = dd < 10 ? `0${dd}` : dd;
  mm = mm < 10 ? `0${mm}` : mm;
  
  return `${dd}/${mm}/${yyyy}`;
};

export const formatDateToDD = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  let dd = date.getDate();
  let mm = date.getMonth() + 1; // Months are zero-indexed
  const yyyy = date.getFullYear();
  
  dd = dd < 10 ? `0${dd}` : dd;
  mm = mm < 10 ? `0${mm}` : mm;
  
  return `${dd}-${mm}-${yyyy}`;
};
// export const calculateLeaseDuration = (leaseStartDate, leaseEndDateStr) => {
//   if (!leaseStartDate || !leaseEndDateStr) return 'N/A';
//   const leaseEndDate = new Date(leaseEndDateStr);
//   const diffMonths = (leaseEndDate.getFullYear() - leaseStartDate.getFullYear()) * 12 +
//                      (leaseEndDate.getMonth() - leaseStartDate.getMonth());
//   return `${diffMonths} month(s)`;
// };


export const calculateLeaseDuration = (startDate, endDate) => {
  // Handle null or undefined inputs
  if (!startDate || !endDate) {
    return 0;
  }

  // Convert string dates to Date objects if necessary
  const start = startDate instanceof Date ? startDate : new Date(startDate);
  const end = endDate instanceof Date ? endDate : new Date(endDate);

  // Check for invalid dates
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return 0;
  }

  // Calculate difference in months
  let months = (end.getFullYear() - start.getFullYear()) * 12;
  months += end.getMonth() - start.getMonth();

  // Adjust for partial months based on day of month
  const dayDifference = end.getDate() - start.getDate();
  
  // If the end date's day is earlier in the month than the start date's day,
  // we subtract a small amount to avoid rounding up inappropriately
  if (dayDifference < 0) {
    months -= (start.getDate() - end.getDate()) / 30;
  } 
  // If the end date's day is later, we add a small amount to account for the extra days
  else if (dayDifference > 0) {
    months += dayDifference / 30;
  }

  // Return rounded value for display
  return Math.round(months);
};
